"use client";

import React, { useState } from "react";
import { observer } from "mobx-react";
import { FilesFoldersListAndPreview } from "../blocks/TerracedGridTheme/FilesFoldersBlock/FilesFoldersBlock";
import { ISchoolFeedUrlQueries } from "../../utils/SchoolBlocksUtilities";
import { useSchoolFeedInfiniteScroll } from "./hooks/useSchoolFeedInfiniteScroll";
import { InitialLoadingIndicatorWrapper } from "./InitialLoadingIndicatorWrapper";
import {
  IReactiveFileContentItem,
  IReactiveFolderContentItem,
} from "./SchoolFeedContentItem";
import { deleteContentItem } from "../blocks/TerracedGridTheme/Terrace";

const SchoolFeedFilesDisplay: React.FC<{
  urlQuery: ISchoolFeedUrlQueries;
}> = observer(() => {
  const {
    contentItems,
    showViewMore,
    isLoading,
    size,
    setSize,
    mutate,
    error,
  } = useSchoolFeedInfiniteScroll("files", {
    is_file: true,
    is_folder: true,
  });
  const [loading, setLoading] = useState(false);

  async function handleDeleteContentItem(
    contentItem: IReactiveFileContentItem,
  ) {
    await deleteContentItem(contentItem);
    await mutate();
  }

  return (
    <InitialLoadingIndicatorWrapper
      initialFetchIsLoading={contentItems.length === 0 && isLoading}
      dataSize={contentItems.length}
      errorCode={error?.status}
      showInitialLoadingIndicator={true}
    >
      <div>
        <FilesFoldersListAndPreview
          useInfiniteScroll={process.env.NEXT_PUBLIC_APP_CTX === "schoolfeed"}
          handleFetchMore={() => {
            setLoading(true);
            setSize(size + 1);
            setLoading(false);
          }}
          shouldFetchMore={showViewMore}
          loadingMore={loading}
          filesAndFolders={
            contentItems as unknown as Array<
              IReactiveFileContentItem & IReactiveFolderContentItem
            >
          }
          expandedView={false}
          handleDelete={handleDeleteContentItem}
          editing={false}
          blockObj={{} as IFilesTerraceBlock}
          aboveTheFold={true}
        />
      </div>
    </InitialLoadingIndicatorWrapper>
  );
});

export default SchoolFeedFilesDisplay;
